var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-page"},[_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-and-header"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"footer-wrapper"},[_c('copyright-footer')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }